import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoutesApplications} from './app.routes';
import {MainComponent} from './base-component/main.component';
import {PublicComponent} from "./public/public.component";
import {LoginComponent} from "./login/login.component";

const routes: Routes = [
  {
    path: 'app',
    component: MainComponent,
    // canActivate: [UserAuthGuard],
    children: [
      ...RoutesApplications
    ]
  },
  {
    path: 'public',
    component: PublicComponent,
    // canActivate: [ClientAuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {path: '', redirectTo: '/app', pathMatch: 'full'},
  {path: '**', redirectTo: '/app'}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts